export enum NotificationTypeEnum {
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error'
}
